import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import "./i18n";
import "@fontsource/inter/latin.css";
import "@fontsource/rubik/hebrew.css";
import "./styles/marketing.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import I18nMuiProvider from "./components/I18nMuiProvider";
import { UiProvider } from "./contexts/UiContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UiProvider>
      <I18nMuiProvider>
        <AuthProvider>
          <HelmetProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </HelmetProvider>
        </AuthProvider>
      </I18nMuiProvider>
    </UiProvider>
  </React.StrictMode>
);


